import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const roleBasedNotificationsRoute: InvariantJiraRoute = {
	name: 'eoc-role-based-notifications',
	path: '/jira/settings/products/ops/role-based-notifications',
	exact: true,
};
